<app-feature-hero
    variant="itsm"
    title="Problem Management Software"
    description="Manage problem lifecycles with Gen AI-based root cause analysis"
    image="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-problem-management-bg-01-01.png"
    imageAlt="Problem management hero image"
></app-feature-hero>

<section class="container section-spacing">
  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title">Problem Management Tool for Incident Prevention</h2>
        <p class="section-paragraph">
          Infraon ITSM’s problem management feature comes with Gen AI power to manage the full
          lifecycle of problems. Detect and get appropriate solutions to maintain digital workspace
          efficiency– 24X7. Use Gen AI-powered automated workflows to seamlessly prevent the
          recurrence of incidents and minimize the impact of service issues.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-problem-management-feature-1-01.webp"
        width="100%"
        alt="Handle problems collaboratively prevent workspace incidents"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <h2 class="section-title text-center p-b-60" style="margin-bottom: 0 !important">
    Key Benefits of Problem Management Software
  </h2>

  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h2 class="section-title sub-title">Problem Identification & Analysis</h2>
        <p class="section-paragraph sub-paragraph">
          Infraon ITSM helps identify problems by detecting duplicate/recurring issues through
          AI-based trend analysis. Analyze data from internal/external sources, perform problem
          analysis, and document workarounds. Infraon ITSM also comes with the Infraon Workspace
          module to collaborate, assess, and unearth contributory causes.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-workflow-management-feature-5-01.png"
        class="w-90"
        alt="Head office - primary"
      />
    </div>
  </div>

  <div class="row mx-0 align-items-center section-spacing reverse-col">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-change-management-feature-3-01.png"
        class="w-90"
        alt="ITSM feature showing ticket management"
      />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-right">
        <h3 class="section-title sub-title">Error Control with Problem Management Tool</h3>
        <p class="section-paragraph sub-paragraph">
          Infraon ITSM helps manage known errors and enables potential permanent solutions (from
          cost and risk POVs). Take into account the level of service delivery impact with regular
          error assessment so that your workspace remains as problem-free as possible.
        </p>
      </div>
    </div>
  </div>

  <div class="row mx-0 align-items-center">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <div class="illustrated-feature-container-text-left">
        <h3 class="section-title sub-title">AI Dashboard in Problem Management Software</h3>
        <p class="section-paragraph sub-paragraph">
          Infraon ITSM provides full visibility of your workspace’s problem management process with
          a Gen AI-based dashboard. Effortlessly track the resolution of existing problems in real
          time and make it a breeze for multiple teams to collaborate - saving a ton of time and
          effort.
        </p>
      </div>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-problem-management-feature-4-01.png"
        class="w-90"
        alt="event management"
      />
    </div>
  </div>
</section>

<section class="container section-spacing">
  <div class="row mx-0 d-flex align-items-center position-relative">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 section-spacing">
      <h3 class="section-title">Other Features of Problem Management Software</h3>

      <div class="row mx-0 px-0">
        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Mobile Accessibility</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Reporting & Analytics</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Ticket Management</p>
          </li>
        </ul>
        <ul class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 px-0">
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Custom Alerts</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Custom Workflows</p>
          </li>
          <li class="d-flex align-items-center my-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                fill="#231F20"
              />
              <mask
                id="mask0_2106_28640"
                style="mask-type: luminance"
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="21"
                height="21"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.997 10.9741H21C21.551 10.9741 21.999 11.4201 22 11.9711C22.008 14.6421 20.975 17.1571 19.091 19.0511C17.208 20.9451 14.7 21.9921 12.029 22.0001H12C9.33905 22.0001 6.83605 20.9681 4.94905 19.0911C3.05505 17.2081 2.00805 14.7001 2.00005 12.0291C1.99205 9.35712 3.02505 6.84312 4.90905 4.94912C6.79205 3.05512 9.30005 2.00812 11.971 2.00012C12.766 2.01212 13.576 2.09212 14.352 2.27812C14.888 2.40812 15.219 2.94812 15.089 3.48512C14.96 4.02112 14.417 4.35112 13.883 4.22312C13.262 4.07312 12.603 4.01012 11.977 4.00012C9.84005 4.00612 7.83305 4.84412 6.32705 6.35912C4.82005 7.87412 3.99405 9.88612 4.00005 12.0231C4.00605 14.1601 4.84405 16.1661 6.35905 17.6731C7.86905 19.1741 9.87105 20.0001 12 20.0001H12.023C14.16 19.9941 16.167 19.1561 17.673 17.6411C19.18 16.1251 20.006 14.1141 20 11.9771C19.999 11.4251 20.445 10.9751 20.997 10.9741ZM8.29305 11.293C8.68405 10.902 9.31605 10.902 9.70705 11.293L11.951 13.537L18.248 6.34102C18.612 5.92802 19.243 5.88402 19.659 6.24802C20.074 6.61102 20.116 7.24302 19.752 7.65902L12.752 15.659C12.57 15.867 12.31 15.99 12.033 16H12C11.735 16 11.481 15.895 11.293 15.707L8.29305 12.707C7.90205 12.316 7.90205 11.684 8.29305 11.293Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_2106_28640)">
                <rect width="24" height="24" fill="#0D51D9" />
              </g>
            </svg>
            <p class="section-paragraph ms-2 mb-0">Custom Roles</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
      <img
        src="/assets/img/feature-pages/infraon-itsm/problem-management/itsm-change-management-feature-5-01.svg"
        class="float-end m-d-none"
        alt="Other Service"
      />
    </div>
  </div>
</section>

<section class="section-spacing primary-bg trial-now">
  <div class="container">
    <h2 class="section-title text-center text-white">
      <span class="text-lowercase">How about a free trial with NO credit card required?</span>
    </h2>

    <div class="d-flex justify-content-center">
      <a
        routerLink="/itsm-tool/prices/itsm-pricing"
        class="primary-buttons cta-buttons rounded-full"
        >Start now</a
      >
    </div>
  </div>
</section>

<section class="section-spacing bg-grey">
  <div class="container">
    <h4 class="section-title text-center">Discover Additional ITSM Features by Infraon</h4>

    <div class="row mx-0">
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/incident-management-software"
            aria-label="Know more about Incident Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/incident-mgmt.svg"
              alt="incident management icon"
            />
            <p class="section-title-s text-start">Incident Management</p>
            <p>
              Collaborate across teams to resolve incidents quickly and minimize business impact.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/event-management"
            aria-label="Know more about Event Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/event-mgmt.svg"
              alt="Event Management icon"
            />
            <p class="section-title-s text-start">Event Management</p>
            <p>Real-time event detection and collection with API-based data and service context.</p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/knowledge-management-software"
            aria-label="Know more about Knowledge Base Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/knowledge-mgmt.svg"
              alt="Knowledge Base Management icon"
            />
            <p class="section-title-s text-start">Knowledge Base Management</p>
            <p>
              Gen AI-powered knowledge base provides self-service options and faster issue
              resolution.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/service-request-management"
            aria-label="Know more about Service Request Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/service-mgmt.svg"
              alt="Service Request Management icon"
            />
            <p class="section-title-s text-start">Service Request Management</p>
            <p>
              Streamlined handling of user requests with automated workflows and efficient resource
              allocation.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/change-management-software"
            aria-label="Know more about Change Management"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/change-mgmt.svg"
              alt="Change Management icon"
            />
            <p class="section-title-s text-start">Change Management</p>
            <p>
              Systematic handling of IT changes reduces risk and ensures controlled service updates.
            </p>
          </a>
        </div>
      </div>
      <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 p-4">
        <div class="backlink-container bg-white h-100" style="border: 1px solid #0000001c">
          <a
            routerLink="/itsm-tool/features/workflow-automation"
            aria-label="Know more about Workflow Automation"
          >
            <img
              class="feature-icon"
              src="/assets/img/feature-pages/infraon-itsm/problem-management/workflow-mgmt.svg"
              alt="Workflow Automation icon"
            />
            <p class="section-title-s text-start">Workflow Automation</p>
            <p>
              Custom automated workflows streamline processes and enable business rule
              implementation.
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<app-faqs [faqs]="faqs" [theme]="'itsm-theme'"></app-faqs>

<section class="section-spacing bg-grey">
  <div class="container" id="g2-box-wrapper">
    <div class="g2-box justify-content-between">
      <img loading="lazy" src="/assets/img/feature-pages/g2.svg" alt="G2 Logo" />
      <p>
        Already love using our products? Please <br />
        share your experiences on G2
      </p>
      <a href="https://www.g2.com/products/infraon-assets/reviews" class="primary-button"
        >Rate us</a
      >
    </div>
  </div>
</section>
